module.exports = __webpack_public_path__ + "static/assets/db16294cb6e01faf0ecc6aa5eb4347ff.png";